import React, { useState } from "react";
import { Div, Modal, Icon, Button } from "atomize";
import Swiper from "react-id-swiper";
import SolvedModalSlider from "../components/common/SolvedModalSlider";

const SolvedModal = ({ isOpen, onClose, items, swiperIndex }) => {
  const [swiper, updateSwiper] = useState(null);

  const resourceSwiperParams = {
    slidesPerView: 1,
    getSwiper: updateSwiper,
    spaceBetween: 16,
    mousewheel: {
      forceToAxis: true,
      invert: true,
    },
    noSwipingSelector: "button",
    effect: "fade",
  };

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  return (
    <Modal
      className="solved-slider"
      isOpen={isOpen}
      onClose={onClose}
      maxW={{ lg: "59rem", md: "44rem", xs: "22rem" }}
      p="0"
      rounded="0"
      align="center"
    >
      <Div className="full-height-swiper">
        <Swiper {...resourceSwiperParams} initialSlide={swiperIndex}>
          {items.map((item, index) => {
            return (
              <div key={index}>
                <SolvedModalSlider
                  content={item}
                  close={onClose}
                  next={goNext}
                  prev={goPrev}
                />
              </div>
            );
          })}
        </Swiper>
      </Div>
      <Icon
        d={{ xs: "none", md: "block", lg: "block" }}
        name="Cross"
        size="27px"
        pos="absolute"
        top="1rem"
        right="1rem"
        onClick={onClose}
        zIndex="200"
        cursor="pointer"
      />
      <Icon
        d={{ xs: "block", md: "none", lg: "none" }}
        name="Cross"
        pos="absolute"
        top={{ xs: "-2rem", md: "0rem" }}
        right={{ xs: "-0.5rem", md: "-2.5rem" }}
        size="27px"
        onClick={onClose}
        cursor="pointer"
        color="white"
        zIndex="100"
      />
    </Modal>
  );
};
export default SolvedModal;
